import React from 'react'
import CreateTeamBtn from './CreateTeamBtn'
import JoinTeam from './JoinTeam'

const NotInGroupComp = (props) => {
    return (
        <>
            <h2>No team found!</h2>
            <h3 className=' mb-1 ' >Please do one of the following:</h3>
            <JoinTeam
                setTeamMembers={props.setTeamMembers}
                setInGroup={props.setInGroup}
                setTeamName={props.setTeamName}
                assignTeam={props.assignTeam}
            />
            <CreateTeamBtn
                assignTeam={props.assignTeam}
                setTeamMembers={props.setTeamMembers}
                setInGroup={props.setInGroup}
                setTeamName={props.setTeamName}
            />
        </>
    )
}

export default NotInGroupComp